import { useState, useEffect } from "react";
import { usersApi } from "../../api/dashboard/usersApi";

export const useUsersList = (allUsers = false, role = "admin") => {
  const [usersList, setUsersList] = useState([]);

  useEffect(() => {
    const fetchPairsList = async (allUsers) => {
      try {
        const data = await usersApi.list(allUsers);
        setUsersList(data);
      } catch (error) {
        console.error("Error fetching pairs data:", error);
      }
    };
    if (role !== "user") fetchPairsList(allUsers);
  }, []);

  return usersList.data;
};
